import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick((prev) => !prev);
  const closeMobileMenu = () => setClick(false);

  return (
    <header>
      <nav
        className="navbar"
        aria-label="Glavna navigacija veterinarske ordinacije"
      >
        <div className="navbar-container">
          <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
            <img
              src="/images/logopezoog.png"
              alt="Veterinarska ordinacija Zagreb"
              className="navbar-logo"
            />
            <span className="brand-subtitle">
              Veterinarska ordinacija Zagreb – specijalisti za male životinje
            </span>
          </Link>

          <button
            type="button"
            className="menu-icon"
            onClick={handleClick}
            aria-label="Otvori navigacijski meni"
            aria-expanded={click}
            aria-controls="main-navigation"
          >
            {click ? <FaTimes /> : <FaBars />}
          </button>

          <ul
            id="main-navigation"
            className={click ? "nav-menu active" : "nav-menu"}
            aria-label="Glavni meni"
          >
            <li className="nav-item">
              <Link
                to="/"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Veterinar Zagreb
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/usluge"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Veterinarske usluge
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/galerija"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Galerija životinja
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/tim"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Veterinarski tim
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/kontakt"
                className="nav-links nav-contact"
                onClick={closeMobileMenu}
              >
                Kontakt veterinar Zagreb
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;